const SkillData = [
  {
    skill: "Illustration",
    A: 90,
    fullMark: 100
  },
  {
    skill: "Graphic Design",
    A: 85,
    fullMark: 100
  },
  {
    skill: "Animation",
    A: 70,
    fullMark: 100
  },
  {
    skill: "Concept Arts",
    A: 70,
    fullMark: 100
  },
  {
    skill: "English",
    A: 85,
    fullMark: 100
  },
  {
    skill: "Japanese",
    A: 87,
    fullMark: 100
  }
];

const ToolData = [
  {
    tool: "Photoshop",
    B: 100,
    fullMBrk: 100
  },
  {
    tool: "Maya",
    B: 95,
    fullMark: 100
  },
  {
    tool: "Unity",
    B: 80,
    fullMark: 100
  },
  {
    tool: "Git",
    B: 45,
    fullMark: 100
  },
  {
    tool: "3ds max",
    B: 70,
    fullMark: 100
  },
  {
    tool: "Premium",
    B: 60,
    fullMark: 100
  },
  {
    tool: "Illustrator",
    B: 80,
    fullMark: 100
  }
];

export default { SkillData, ToolData };
